import { DateFormat, formatDate, parseDate } from '@chillibean/component-library';

import { StudyProtocol } from './StudyProtocol';

export class Site {
  constructor(params) {
    this.country = params.country;
    this.goLiveDate = params.goLiveDate && parseDate(params.goLiveDate, DateFormat.ISO_DATE);
    this.id = params.id;
    this.identifier = params.identifier;
    this.name = params.name;
    this.studyProtocol = params.studyProtocol ? new StudyProtocol(params.studyProtocol) : null;
  }

  getDetails() {
    return [
      `Identifier: ${this.identifier}`,
      `Country: ${this.country}`,
      `Go live date: ${formatDate(this.goLiveDate)}`,
    ];
  }
}

export default Site;
